import { ChevronRight } from 'lucide-react';
import { formatRelativeTime, getActionVisual } from '../actionVisuals';
import type { AgentAction } from '../types';

interface ActivityFeedItemProps {
  action: AgentAction;
  onClick: () => void;
}

export default function ActivityFeedItem({ action, onClick }: ActivityFeedItemProps) {
  const visual = getActionVisual(action);
  const { Icon } = visual;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full text-left cursor-pointer rounded-lg px-4 py-3.5 flex items-center gap-3.5 transition-all hover:shadow-md hover:-translate-y-px border border-gray-200/80 dark:border-gray-700 border-l-4 shadow-sm ${visual.rowTintClass} ${visual.rowBorderClass}`}
    >
      <div
        className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${visual.circleClass}`}
        style={visual.circleStyle}
      >
        <Icon className={`w-[18px] h-[18px] ${visual.iconClass}`} style={visual.iconStyle} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 m-0 mb-0.5 truncate">{action.title}</p>
        <p className="text-xs text-gray-600 dark:text-gray-400 m-0 truncate">{action.subtitle}</p>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 m-0 flex-shrink-0 font-medium">
        {formatRelativeTime(action.timestamp)}
      </p>
      <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
    </button>
  );
}
